import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import AddModals from '../../components/modals/addModals';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { isAuxFormatter, natureFormatter, natureTextFormatter } from '../../components/formatters/defFormatter';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { selectStyles } from '../../components/dropDown/selectStyle';

import { Space, Input, Tag, Button, Tabs, Checkbox } from 'antd';


import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import CashAccountForm from './cashAccountForm';




function CashAccount(props) {

  let { } = props;


  const { userData, settingData, refData, api, secondaryCurrency, yearId, companyId, mainCurrency, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', type: ['Cash'], companyId, yearId, isDebtors: false, isCreditors: false });

  const [showModal, setShowModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);



  const table = 'account';
  const title = 'Cash';



  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }






  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        name: item.english,
        Phone: item.phone,
        Address: item.address,
        Type: item.type,
        group: item.group ? item.group.name : null,
        Balance: item.balance,
        balance: item.secondaryBalance,
        Nature: natureTextFormatter(item.isDebit, item),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };




  const columnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id', width: '10%', sorter: (a, b) => a.age - b.age, render: (id, record) => (record.parent?.accountId + '.' + record.accountId) },
    { title: contentLanguages.Name, dataIndex: 'english' },
    { title: contentLanguages.Phone, dataIndex: 'phone' },
    { title: contentLanguages.Address, dataIndex: 'address' },
    { title: contentLanguages.Type, dataIndex: 'type' },
    { title: contentLanguages.Group, dataIndex: 'group', render: (group) => (group?.name) },
    { title: contentLanguages.Balance + ' ' + mainCurrency.code, dataIndex: 'balance', width: '8%', render: numberFormatter },
    { title: contentLanguages.Balance + ' ' + secondaryCurrency.code, dataIndex: 'secondaryBalance', width: '8%', render: numberFormatter },
    { title: contentLanguages.Nature, dataIndex: 'isDebit', width: '8%', render: natureFormatter },
    {
      title: contentLanguages.Edt,
      width: '5%',
      render: (_, record) => (
        <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => openModal(record)} />
      ),
    },
    {
      title: contentLanguages.Void,
      width: '5%',
      render: (_, record) => (record.isActive ? (
        <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
      ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
      )
    }
  ].filter(Boolean), []);



  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );


  const onCheckChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    setFilter((prev) => ({
      ...prev,
      [name]: checked,
    }));

    if (name == 'isDebtors') {
      setFilter((prev) => ({
        ...prev,
        isCreditors: false,
      }));
    }
    else if (name == 'isCreditors') {
      setFilter((prev) => ({
        ...prev,
        isDebtors: false,
      }));
    }
  };



  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>

          <Row className='g-1 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={1}>
            </Col>

            <Col md={4} style={{ marginTop: '5px' }}>
              <Checkbox onChange={onCheckChange} checked={filter.isDebtors} name="isDebtors">
                Show Debtors
              </Checkbox>
              <Checkbox onChange={onCheckChange} checked={filter.isCreditors} name="isCreditors">
                Show Creditors
              </Checkbox>
            </Col>


            <Col md={3}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => openModal(null)} >Add</Button>
            </Col>

          </Row>



          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            data={{ id: idRow?.id }}
          />


          <CashAccountForm
            showModal={showModal}
            toggleModal={openModal}
            idRow={idRow}
            setIdRow={setIdRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
          />




        </>
      }

    </div>
  )
}

export default CashAccount;
